import React, { useRef } from 'react';
import RNTU from '../../../assets/images/logos/clients/RNTU.jpg';
import Khushilal from '../../../assets/images/logos/clients/Khushilal.png';
import SRK from '../../../assets/images/logos/clients/SRK.jpg';
import AIMS from '../../../assets/images/logos/clients/Aims.jpg';
import Manit from '../../../assets/images/logos/clients/Manit.jpg';
import CRIST from '../../../assets/images/logos/clients/Crist.jpg';
import CIPAT from '../../../assets/images/logos/clients/CIPAT.jpg';

const universities = [
  { name: 'AIIMS Bhopal', logo: AIMS },
  { name: 'SRK University', logo: SRK },
  { name: 'Khushilal Hospital', logo: Khushilal },
  { name: 'CHRIST University', logo: CRIST },
  { name: 'MANIT University', logo: Manit },
  { name: 'CIPET INSTITUTE', logo: CIPAT },
  { name: 'RNTU University', logo: RNTU },
];

const Clients = () => {
  const containerRef = useRef(null);
  const touchStartX = useRef(0);
  const scrollLeft = useRef(0);

  // Touch event handlers
  const handleTouchStart = e => {
    touchStartX.current = e.touches[0].clientX;
    scrollLeft.current = containerRef.current.scrollLeft;
  };

  const handleTouchMove = e => {
    const touchCurrentX = e.touches[0].clientX;
    const touchDiffX = touchCurrentX - touchStartX.current;
    containerRef.current.scrollLeft = scrollLeft.current - touchDiffX;
  };

  return (
    <div className='flex flex-col overflow-hidden p-5 bg-gray-100'>
      <h1 className='text-center text-3xl font-semibold mb-5 md:text-2xl sm:text-xl xs:text-lg'>
        Our Clients
      </h1>

      <div
        ref={containerRef}
        className='flex gap-24 whitespace-nowrap overflow-x-auto scroll-smooth py-2.5 touch-pan-x'
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        {universities.map((university, index) => (
          <div
            key={index}
            className='flex flex-col items-center text-center min-w-[150px] lg:min-w-[120px] md:min-w-[100px] sm:min-w-[80px]'
          >
            {university.logo && (
              <div
                className='w-[150px] h-[100px] 
                     lg:w-[120px] lg:h-[90px] 
                     md:w-[100px] md:h-[80px] 
                     sm:w-[80px] sm:h-[60px] 
                     flex items-center justify-center mb-2.5 
                     transition-transform duration-300 ease-in-out hover:scale-110'
              >
                <img
                  src={university.logo}
                  alt={`${university.name} Logo`}
                  className='object-contain w-full h-full'
                />
              </div>
            )}
            <p
              className='text-base font-bold text-gray-800 
                    lg:text-sm 
                    md:text-xs 
                    sm:text-[10px]'
            >
              {university.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Clients;
